/**
 * WebGL context types - extracted to break circular dependency
 * between SharedWebGLContext.ts and activeSharedWebGL.ts
 */

export enum WebGLContextReuse {
  AUTO, // Will reuse if the options are the same.
  ALWAYS_REUSE, // Prefer reuse even if a context has been previously initialized with different options.
  FORCE_NEW,
}

export interface SharedWebGLOptions {
  reuse: WebGLContextReuse;
  throwOnGLError?: boolean;
  logGLResourceUsage?: boolean;
  onScreenRenderingDisabled?: boolean; // If true, the default framebuffer can be used as a scratch buffer to generate JPG/PNG images.
}
